import React from 'react';
import { Shield, ArrowRight } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function OfferSection() {
  const handleBuyClick = () => {
    // Fire Meta Pixel InitiateCheckout event
    trackInitiateCheckout(7.29, 'USD');
  };
  return <section id="offer" className="w-full bg-white py-12 px-4 sm:py-16 sm:px-6 md:py-28" data-id="element-159">
      <div className="max-w-4xl mx-auto" data-id="element-160">
        {/* Transformation - Condensed */}
        <div className="text-center mb-12" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4C1D95] mb-4" data-id="element-162">
            Lo que vas a sentir: <span className="text-[#84CC16]" data-id="element-163">Calma.</span>
          </h2>
          <p className="text-lg text-[#444444] max-w-2xl mx-auto" data-id="element-164">
            Porque por fin tienes un criterio para decidir qué hacer hoy y saber
            si funcionó.
          </p>
        </div>

        {/* Offer Card */}
        <div className="bg-[#4C1D95] text-white rounded-2xl sm:rounded-3xl p-6 sm:p-10 shadow-2xl relative overflow-hidden" data-id="element-165">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-64 sm:w-96 h-64 sm:h-96 bg-[#7C3AED]/20 rounded-full -mr-20 -mt-20 blur-3xl" data-id="element-166"></div>
          <div className="absolute bottom-0 left-0 w-48 sm:w-64 h-48 sm:h-64 bg-[#84CC16]/10 rounded-full -ml-20 -mb-20 blur-3xl" data-id="element-167"></div>

          <div className="relative z-10 flex flex-col items-center text-center md:flex-row md:items-center md:justify-between md:text-left gap-8" data-id="element-168">
            <div className="flex-1" data-id="element-169">
              <h3 className="text-3xl font-serif font-bold mb-2" data-id="element-170">
                Sanar en Movimiento
              </h3>
              <p className="text-[#A3E635] text-lg mb-6 font-medium" data-id="element-171">
                Ebook + Checklists + Plantillas
              </p>

              <div className="flex items-center justify-center md:justify-start gap-4 mb-6" data-id="element-172">
                <span className="text-5xl font-bold text-white" data-id="element-173">$7.29</span>
                <span className="text-sm text-purple-300 uppercase tracking-wide text-left leading-tight" data-id="element-174">
                  Pago
                  <br data-id="element-175" />
                  Único
                </span>
              </div>

              <div className="flex items-start gap-3 bg-[#5B21B6] p-4 rounded-lg border border-[#7C3AED]" data-id="element-176">
                <Shield className="w-5 h-5 text-[#A3E635] flex-shrink-0 mt-0.5" data-id="element-177" />
                <p className="text-sm text-purple-200 text-left" data-id="element-178">
                  <span className="text-white font-bold" data-id="element-179">
                    Garantía de 7 días:
                  </span>{' '}
                  Si no te da claridad total, te devolvemos tu dinero. Sin
                  preguntas.
                </p>
              </div>
            </div>

            <div className="w-full md:w-auto" data-id="element-180">
              <a href="https://mindmeetsmovement.com/cart/47324808413414:1" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="w-full md:w-auto px-8 py-4 bg-[#84CC16] hover:bg-[#65A30D] active:scale-[0.98] text-[#1a1a1a] text-xl font-bold rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center group" data-id="element-181">
                Empieza hoy
                <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-182" />
              </a>
              <p className="mt-3 text-xs text-center text-purple-300" data-id="element-183">
                Descarga digital inmediata
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}